import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import AdvancedSearch from "./components/AdvancedSearch";
import PhraseDetail from "./components/PhraseDetail";
import UpdateWord from "./components/UpdateWord";
import TranslateWord from "./components/Translate";
import AddWord from "./components/AddWord";
import AddRequest from "./components/AddRequest";
import Login from "./components/Login";
import Register from "./components/Register";
import Logout from "./components/Logout";
import About from "./components/About";
// Claude: new page — "update [USER_MANUAL.md], and make it accessible on the site."
import UserManual from "./components/UserManual";
import Contact from "./components/Contact";
import "./i18n.js";
import { MathJaxContext } from "better-react-mathjax";
import { SharedStateProvider } from "./context/sharedstate";
import ReactModal from "react-modal";
import ListRequests from "./components/ListRequests.js";
import UserRoleManager from "./components/UserRoleManager.js";
import UserLys from "./components/UserLys.js";
import QRCodeGenerator from "./components/QrGenerator.js";
import PasswordResetRequest from './components/PasswordResetRequest';
import PasswordResetForm from './components/PasswordResetForm';
// Claude: new component — alpha-tester feedback: "add a password reset function for logged in
// Claude: users." Distinct from the two above (which are for a user who can't log in at all).
import ChangePassword from './components/ChangePassword';
// Claude: new components for specification.md Phase 2 (suggestion-review workflow).
import ReviewQueue from './components/ReviewQueue';
import MySuggestions from './components/MySuggestions';
import MissingTerms from './components/MissingTerms';
// Claude: new component for specification.md Phase 3 (DB optimiser/cleaner).
import DuplicateCleanup from './components/DuplicateCleanup';
// Claude: new component for the administrator-only user-management page (specification.md's known-bugs list).
import UserAdmin from './components/UserAdmin';
// Claude: new component for the two admin-only term functions (bulk CSV upload + filtered CSV
// Claude: export) requested directly by the user.
import TermAdmin from './components/TermAdmin';
// import PasswordResetRequest from './components/PasswordResetRequest';
// import PasswordResetForm from './components/PasswordResetForm';

// const cors = require("cors");
// App.use(cors());

// import history from './history';
ReactModal.setAppElement("#root");

function App() {
  // const history = useHistory();
  const [isLoggedIn] = React.useState(false);

  const mjconfig = {
    loader: { load: ["[tex]/html"] },
    tex: {
      packages: { "[+]": ["html"] },
      inlineMath: [
        ["$", "$"],
        ["\\(", "\\)"],
      ],
      displayMath: [
        ["$$", "$$"],
        ["\\[", "\\]"],
      ],
    },
  };

  // const handleLogout = () => {
  //   setIsLoggedIn(false);
  //   // Perform any additional logout logic
  // };

  return (
    <SharedStateProvider>
      <MathJaxContext  version={3} config={mjconfig}>
        {/* <AuthProvider > */}
        <Router>
          <Routes>
            {/* <Route exact path="/">
          <LandingPage isLoggedIn={isLoggedIn} onLogout={handleLogout} />
        </Route> */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/advanced" element={<AdvancedSearch />} />
            <Route
              path="/update/:id"
              element={<UpdateWord />}
              component={isLoggedIn ? UpdateWord : Login}
            />
            <Route
              path="/translate/:id"
              element={<TranslateWord />}
              component={isLoggedIn ? TranslateWord : Login}
            />
            <Route
              path="/requestedterms"
              element={<ListRequests />}
              component={isLoggedIn ? ListRequests : Login}
            />
            <Route
              path="/addword"
              element={<AddWord />}
              // component={isLoggedIn ? AddWord : Login}
            />
            <Route
              path="/userlys"
              element={<UserLys />}
              component={isLoggedIn ? UserLys : Login}
            />
            <Route
              path="/userroles"
              element={<UserRoleManager />}
              component={isLoggedIn ? UserRoleManager : Login}
            />
            <Route
              path="/addrequest/"
              element={<AddRequest />}
              // component={isLoggedIn ? AddWord : Login}
            />
            {/* Claude: new routes for specification.md Phase 2 (suggestion-review workflow). Role
                gating happens server-side (review-queue/review-word are approver/administrator
                only); these routes themselves are reachable by anyone logged in, same pattern as
                /userroles above. */}
            <Route path="/review-queue" element={<ReviewQueue />} />
            <Route path="/my-suggestions" element={<MySuggestions />} />
            <Route path="/missing-terms" element={<MissingTerms />} />
            {/* Claude: new route for specification.md Phase 3 (DB optimiser/cleaner). Role gating
                happens server-side (duplicate-queue/resolve-duplicate are approver/administrator
                only), same pattern as the Phase 2 routes above. */}
            <Route path="/duplicate-cleanup" element={<DuplicateCleanup />} />
            {/* Claude: new route for the administrator-only user-management page (specification.md's
                known-bugs list). Role gating happens server-side (every /v1/admin-users/...
                endpoint is IsAdministrator-only), same pattern as the Phase 2/3 routes above. */}
            <Route path="/user-admin" element={<UserAdmin />} />
            {/* Claude: new route for the two admin-only term functions (bulk CSV upload + filtered
                CSV export) requested directly by the user. Role gating happens server-side (every
                /v1/admin-terms/... endpoint is IsAdministrator-only), same pattern as /user-admin. */}
            <Route path="/term-admin" element={<TermAdmin />} />
            <Route path="/phrase/:id" element={<PhraseDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/user-manual" element={<UserManual />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/register" element={<Register />} />
            <Route path="/qr" element={<QRCodeGenerator />} />
            <Route path="/password-reset" element={<PasswordResetRequest />} />
            {/* Claude: added :uidb64 — the backend's reset link now includes it (see
                custom_auth/urls.py); PasswordResetForm.js reads both params. */}
            <Route path="/reset-password/:uidb64/:token" element={<PasswordResetForm />} />
            {/* Claude: new route — alpha-tester feedback: "add a password reset function for
                logged in users." Reachable by anyone logged in, same pattern as /term-admin etc.;
                the endpoint itself (ChangePasswordView) is IsAuthenticated-gated server-side. */}
            <Route path="/change-password" element={<ChangePassword />} />
            {/* <Route path="/password-reset" component={PasswordResetRequest} />
            <Route path="/reset-password/:token" component={PasswordResetForm} /> */}
            <Route path="*" element={<div>Page not found</div>} />
          </Routes>
        </Router>
        {/* </AuthProvider> */}
      </MathJaxContext>
    </SharedStateProvider>
  );

  // return (
  //   <AuthProvider>
  //     <Router>
  //       <div className="container mx-auto p-4">
  //         <Routes>
  //           <Route path="/" element={<PhraseList />} />
  //           <Route path="/phrase/:id" element={<PhraseDetail />} />
  //           <Route path="/update/:id" element={<UpdateWord />} />
  //           <Route path="/add" element={<AddWord />} />
  //           <Route path="/login" element={<Login />} />
  //         </Routes>
  //       </div>
  //     </Router>
  //   </AuthProvider>
  // );
}

export default App;
